import kebabCase from 'lodash/kebabCase';

export const postsPath = (page: number, forcePagePath: boolean = false) => {
    const slug = '/posts';
    return page > 1 || forcePagePath ? `${slug}/page/${page}` : `${slug}/`;
};

export const postPath = (post: string) => `/posts/${kebabCase(post)}`;

export const categoryPath = (
    category: string,
    page: number,
    forcePagePath: boolean = false,
) => {
    const slug = `/posts/category/${kebabCase(category)}`;
    return page > 1 || forcePagePath ? `${slug}/page/${page}` : `${slug}/`;
};

export const tagPath = (
    tag: string,
    page: number,
    forcePagePath: boolean = false,
) => {
    const slug = `/posts/tag/${kebabCase(tag)}`;
    return page > 1 || forcePagePath ? `${slug}/page/${page}` : `${slug}/`;
};
